(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/participate-in-tipssm.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/participate-in-tipssm.js');

'use strict';

const {
  pay
} = svs.lbUtils.wager;
const {
  getPaymentConfirmMessage
} = svs.components.sport;
const logger = new svs.core.log.Logger('svs.sport.QuickplayModal');
const tipssmParticipateDialog = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  svs.core.module.load('/cl/sport/tipssm-participate-dialog', null, () => {
    const {
      tipssmParticipateDialog
    } = svs.components.sport.tipssmParticipateDialog;
    tipssmParticipateDialog(...args);
  });
};
const participateInTipsSM = _ref => {
  let {
    productId,
    productName,
    drawNumber,
    competitionId,
    wagerToPay,
    wagerProps,
    systemCost,
    successCallback,
    errorCallback
  } = _ref;
  tipssmParticipateDialog({
    productId,
    drawNumber,
    competitionId,
    onParticipate: (compDesc, isCompetitionSignUp) => {
      if (isCompetitionSignUp) {
        logger.info("Joined competition [".concat(competitionId, "] from dialog"));
        wagerProps.competitionSignUp = {
          id: competitionId
        };
      } else {
        logger.info("Accepted wager in competition [".concat(competitionId, "]"));
        wagerToPay.competitionId = [competitionId];
      }
      wagerProps.message = getPaymentConfirmMessage({
        productName,
        amount: systemCost,
        compDesc
      });
      const successCb = () => {
        successCallback({
          compDesc
        });
      };
      wagerProps.extradata.competition = 'TipsSM';
      pay(wagerToPay, wagerProps, successCb, errorCallback);
    },
    onRefuse: userChoice => {
      if (userChoice) {
        logger.info('Declined competition from dialog');
      }
      wagerProps.extradata.competition = 'None';
      pay(wagerToPay, wagerProps, successCallback, errorCallback);
    }
  });
};
setGlobal('svs.components.sport.quickplayModal.participateInTipsSM', participateInTipsSM);

 })(window);